// extracted by mini-css-extract-plugin
export var banner = "_o5-0";
export var settingRow = "_o5-2";
export var titleIcon = "_o5-1";